export default __webpack_public_path__ + "static/media/tavi_big.1e7d5c72.jpg";